import { InputTypes } from "../InputTypes";
import { OptionsSources } from "../OptionsSources";

export const Product = Object.freeze({
  name: {
    visibleName: "Nombre",
    type: InputTypes.TEXT,
    required: true,
  },
  text: {
    visibleName: "Descripción",
    type: InputTypes.RICH_TEXT_AREA,
    required: true,
  },
  price: {
    visibleName: "Precio de venta",
    type: InputTypes.NUMBER,
    min: 0.0,
    step: 0.01,
  },
  offer_price: {
    visibleName: "Precio con descuento",
    type: InputTypes.NUMBER,
    min: 0,
    step: 0.01,
  },
  stock: {
    visibleName: "Stock",
    type: InputTypes.NUMBER,
    min: 0,
  },
  offer: {
    visibleName: "¿Es oferta?",
    type: InputTypes.SELECT,
    optionsMapping: {
      source: OptionsSources.BOOLEAN,
    },
  },
  visible_app: {
    visibleName: "¿Visible en la app?",
    type: InputTypes.SELECT,
    optionsMapping: {
      source: OptionsSources.BOOLEAN,
    },
  },
  internal: {
    visibleName: "Notas internas",
    type: InputTypes.RICH_TEXT_AREA,
  },
  media: {
    visibleName: "Media",
    type: InputTypes.PREVIEW,
  },
});
